module.exports = __webpack_public_path__ + "1aaab70377fb8b75181cdf72b459e716.svg";